import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'
import { App } from '../../App';
import { Surface, Stack, SmartContainer } from '../../styles/Containers'
import { StyledH3, StyledP } from '../../styles/StyledHTML'
import { StyledButton } from '../../styles/matieralui/Button'
import { NoAccess } from '../Alerts/NoAccess';

export const PlanRestrictionPage = ({ upgradeMessage }) => {

    const dispatch = useDispatch();

    const goTo = (path) => dispatch(push(path))

    const message = (upgradeMessage) ? upgradeMessage : 'Upgrade your account to unlock this feature.'

    return (
        <App title="Upgrade">

            <NoAccess />

        </App>
    )
}